import AddCommentOutlinedIcon from '@mui/icons-material/AddCommentOutlined'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import IconButton from '@mui/material/IconButton'
import MuiMenu from '@mui/material/Menu'
import Typography from '@mui/material/Typography'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import MenuItem from './MenuItem'
import AlertDialog from './base/AlertDialog'

type ChatMenuProps = {
  chatId: string | null
  resetChat: () => void
}

const ChatMenu = ({ chatId, resetChat }: ChatMenuProps): ReactElement => {
  const [menuAnchorElement, setMenuAnchorElement] = useState<HTMLElement | null>(null)
  const [newChatConfirmationDialogOpen, setNewChatConfirmationDialogOpen] = useState(false)
  const { t } = useTranslation()

  const cancelNewChat = () => {
    setNewChatConfirmationDialogOpen(false)
  }
  const createNewChat = () => {
    resetChat()
    setNewChatConfirmationDialogOpen(false)
  }
  const confirmNewChat = () => {
    setMenuAnchorElement(null)
    setNewChatConfirmationDialogOpen(true)
  }

  return (
    <>
      <IconButton
        aria-label={t($ => $.common.labels.menu)}
        onClick={event => setMenuAnchorElement(event.currentTarget)}
        aria-expanded={menuAnchorElement !== null}>
        <MoreVertIcon />
      </IconButton>
      <MuiMenu
        anchorEl={menuAnchorElement}
        open={menuAnchorElement !== null}
        onClose={() => setMenuAnchorElement(null)}>
        <MenuItem
          text={t($ => $.chat.startNew.title)}
          icon={<AddCommentOutlinedIcon fontSize='small' />}
          disabled={chatId === null}
          onClick={confirmNewChat}
        />
      </MuiMenu>

      {newChatConfirmationDialogOpen && (
        <AlertDialog
          title={t($ => $.chat.startNew.title)}
          close={() => setNewChatConfirmationDialogOpen(false)}
          actions={
            <DialogActions>
              <Button onClick={cancelNewChat} variant='outlined' sx={{ flex: '1 1' }}>
                {t($ => $.common.actions.cancel)}
              </Button>
              <Button onClick={createNewChat} variant='contained' sx={{ flex: '3 3' }}>
                {t($ => $.chat.startNew.title)}
              </Button>
            </DialogActions>
          }>
          <Typography variant='body2'>{t($ => $.chat.startNew.description)}</Typography>
        </AlertDialog>
      )}
    </>
  )
}

export default ChatMenu
